import React, { useMemo } from "react";
import { Form, Row, Col, FormGroup, Label } from "reactstrap";
import { useTranslation } from "react-i18next";
import Select from "components/Select";
import InventorySearchField from "components/InventorySearchField";
import { getActiveColorStyle } from "utils/colorUtils";
import {
  getTheme2SearchFilterColProps,
  getTheme2SearchFilterSingleSelectStyles,
} from "utils/theme2MultiSelect";

const WebsiteInventoryFilters = ({
  activeColor = "blue",
  isTheme2 = false,
  search,
  onSearchChange,
  status = "all",
  onStatusChange,
}) => {
  const { t } = useTranslation();
  const activeColorStyle = useMemo(
    () => getActiveColorStyle(activeColor),
    [activeColor]
  );
  const filterSelectStyles = useMemo(
    () => getTheme2SearchFilterSingleSelectStyles(activeColorStyle, isTheme2),
    [activeColorStyle, isTheme2]
  );

  const searchColProps = getTheme2SearchFilterColProps(isTheme2, {
    filterColClass: "search-inventory-filter-col",
    md: "6",
  });
  const statusColProps = getTheme2SearchFilterColProps(isTheme2, {
    filterColClass: "search-inventory-filter-col",
    md: "3",
  });

  const statusOptions = useMemo(
    () => [
      { value: "all", label: t("inventoryWebsite.statusAll") },
      { value: "active", label: t("inventoryWebsite.statusActive") },
      { value: "inactive", label: t("inventoryWebsite.statusInactive") },
    ],
    [t]
  );

  const selectedStatus =
    statusOptions.find((option) => option.value === status) || statusOptions[0];

  return (
    <Form>
      <Row className={isTheme2 ? "search-inventory-filters-row" : undefined}>
        <Col {...searchColProps}>
          <FormGroup>
            <Label>{t("inventoryWebsite.search")}</Label>
            <InventorySearchField
              value={search}
              onChange={onSearchChange}
              placeholder={t("inventoryWebsite.searchPlaceholder")}
            />
          </FormGroup>
        </Col>
        <Col {...statusColProps}>
          <FormGroup>
            <Label>{t("inventoryWebsite.statusFilter")}</Label>
            <Select
              activeColor={activeColor}
              className="react-select"
              styles={filterSelectStyles}
              placeholder={t("inventoryWebsite.statusFilter")}
              name="website-inventory-status"
              isSearchable={false}
              isClearable={false}
              value={selectedStatus}
              onChange={(option) => onStatusChange?.(option?.value || "all")}
              options={statusOptions}
            />
          </FormGroup>
        </Col>
      </Row>
    </Form>
  );
};

export default WebsiteInventoryFilters;
